import { render, staticRenderFns } from "./GuppyChatPostListItem.vue?vue&type=template&id=f090c46a&scoped=true&"
import script from "./GuppyChatPostListItem.vue?vue&type=script&lang=js&"
export * from "./GuppyChatPostListItem.vue?vue&type=script&lang=js&"
import style0 from "./GuppyChatPostListItem.vue?vue&type=style&index=0&id=f090c46a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f090c46a",
  null
  
)

export default component.exports